import { scaleLinear } from 'd3-scale';
import { createContext } from 'react';

import { XScale, YScale } from '../types/histogram.js';

export interface DisplayConfig {
  xScale: XScale;
  yScale: YScale;
}

export const DisplayConfigContext = createContext<DisplayConfig>({
  xScale: scaleLinear(),
  yScale: scaleLinear(),
});

DisplayConfigContext['displayName'] = 'DisplayConfigContext';
